export const FILTER_MAPPING = {
  groups: {
    fulltext: 'q'
  },
  pois: {
    fulltext: 'q'
  },
  shops: {
    fulltext: 'q',
    shop_id: 'id__in',
    advert_id: 'advert__in',
    advert_exclusivist: 'advert__exclusivist__in'
  },
  adverts: {
    fulltext: 'q',
    shop_id: 'shop_related__in',
    advert_id: 'id__in',
    advert_is_active: 'is_active',
    advert_has_incidences: 'has_incidences',
    advert_type: 'advert_type__in',
    advert_exclusivist: 'exclusivist__in'
  },
  campaigns: {
    fulltext: 'q',
    direction: 'direction',
    product_id: 'products',
    shop_id: 'shops__in',
    campaign_id: 'id__in',
    campaign_scope: 'scope',
    campaign_status: 'status',
    start_date: 'finish_date__gte',
    finish_date: 'start_date__lte',
    terr_unit: 'terr_unit__in'
  },
  dashboard_summary: {
    campaign_scope: 'campaign__scope',
    start_date: 'date__gte',
    finish_date: 'date__lte',
    campaign_channel_summary: 'type',
    terr_unit: 'terr_unit__in'
  },
  dashboard: {
    direction: 'campaign_channel__direction',
    product_id: 'campaign_channel__products__id__in',
    shop_id: 'campaign__shops__id__in',
    campaign_scope: 'campaign__scope',
    start_date: 'date__gte',
    finish_date: 'date__lte',
    campaign_status: 'campaign__status',
    campaign_id: 'campaign__pk__in',
    terr_unit: 'terr_unit__in'
    // campaign_channel: 'campaign_channel'
  },
  dashboard_extended: {
    direction: 'campaign_channel__direction',
    product_id: 'campaign_channel__products__id__in',
    shop_id: 'campaign__shops__id__in',
    campaign_id: 'campaign__pk__in',
    campaign_scope: 'campaign__scope',
    campaign_status: 'campaign__status',
    start_date: 'start_date',
    finish_date: 'finish_date',
    campaign_channel: 'type',
    terr_unit: 'terr_unit__in'
  },
  dashboard_map: {
    // fulltext: 'stats_campaigns_q',
    direction: 'stats_campaigns_direction',
    product_id: 'stats_campaigns_products',
    shop_id: 'stats_campaigns_shops__in',
    campaign_id: 'stats_campaigns_pk__in',
    campaign_scope: 'stats_campaigns_scope',
    campaign_status: 'stats_campaigns_status',
    start_date: 'stats_campaigns_finish_date__gte',
    finish_date: 'stats_campaigns_start_date__lte'
  },
  users: {
    fulltext: 'q',
    user_role: 'role'
  },
  admin_products: {
    fulltext: 'q'
  },
  billing: {
    shop_id: 'shop_related__in'
  }
}
